<script lang="ts">
    import type { Writable } from 'svelte/store'

    import { toUnicode } from 'punycode-esm'

    import { gettext as _, resolve } from 'hydria/services/gettext'

    interface Props {
        status: Writable<'loading' | 'ready' | 'not-found' | 'error'>
        zoneUnicode: Writable<string | undefined>
        recordErrors: Writable<{ [key: string]: string }>
        class?: string | null
    }

    let { status, zoneUnicode, recordErrors, class: classes = null }: Props = $props()
</script>

{#if $status == 'ready' && Object.keys($recordErrors).length}
    <div>
        <div class="standalone-title text-danger">{$_('Validation errors')}</div>
        <div class="card{classes ? ` ${classes}` : ''}">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{$_('Entry name')}</th>
                                <th>{$_('Error')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each Object.entries($recordErrors) as [idna, error]}
                                <tr>
                                    <td>
                                        {#if idna != ''}<span>{toUnicode(idna)}</span><span class="text-muted">.</span>{/if}<span class="text-muted">{$zoneUnicode}.</span>
                                    </td>
                                    <td>{$resolve(error)}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
{/if}
